import { Injectable } from '@angular/core';
import { ApiService } from './helpers/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { apiResourcesV1 } from './helpers/api-resources';
import { Session } from '../interfaces/session.interface';
import { ScenarioItemTypeNew } from '../enums/scenario-item-type.enum';
import { ScenarioItemSubType } from '../enums/scenario-Item-sub-type.enum';
import { ReferenceType } from '../enums/reference-type.enum';
import { Scenario } from '../interfaces/scenario.interface';
import { ScenarioItem } from '../interfaces/scenario-item.interface';

@Injectable()
export class SessionService {
  constructor(private http: ApiService) {}

  getReferenceTypes() {
    return [
      { value: ReferenceType.MEETING, name: 'ADMIN.REFERENCE_TYPE.MEETING' },
      { value: ReferenceType.VIDEO, name: 'ADMIN.REFERENCE_TYPE.VIDEO' },
      {
        value: ReferenceType.GOOGLE_MAPS,
        name: 'ADMIN.REFERENCE_TYPE.GOOGLE_MAPS',
      },
      { value: ReferenceType.WEB_LINK, name: 'ADMIN.REFERENCE_TYPE.WEB_LINK' },
      { value: ReferenceType.AUDIO, name: 'ADMIN.REFERENCE_TYPE.AUDIO' },
      { value: ReferenceType.DOCUMENT, name: 'ADMIN.REFERENCE_TYPE.DOCUMENT' },
    ];
  }

  getScenarioItemTypes() {
    return [
      {
        value: ScenarioItemTypeNew.BRANCHING,
        name: 'ADMIN.SCENARIO_ITEM_TYPE.BRANCHING',
      },
      {
        value: ScenarioItemTypeNew.RANSOMWARE_LEAK_SITE,
        name: 'ADMIN.SCENARIO_ITEM_TYPE.RANSOMWARE_LEAK_SITE',
      },
      {
        value: ScenarioItemTypeNew.NEWS_POST,
        name: 'ADMIN.SCENARIO_ITEM_TYPE.NEWS_POST',
      },
      {
        value: ScenarioItemTypeNew.WEB_POST_DATA,
        name: 'ADMIN.SCENARIO_ITEM_TYPE.WEB_POST_DATA',
      },
      {
        value: ScenarioItemTypeNew.PHONE_CALL_TRANSCRIPT,
        name: 'ADMIN.SCENARIO_ITEM_TYPE.PHONE_CALL_TRANSCRIPT',
      },
      {
        value: ScenarioItemTypeNew.TEAM_CHAT,
        name: 'ADMIN.SCENARIO_ITEM_TYPE.TEAM_CHAT',
      },
      {
        value: ScenarioItemTypeNew.SERVICE_DESK_TICKET,
        name: 'ADMIN.SCENARIO_ITEM_TYPE.SERVICE_DESK_TICKET',
      },
      {
        value: ScenarioItemTypeNew.EMAIL,
        name: 'ADMIN.SCENARIO_ITEM_TYPE.EMAIL',
      },
      {
        value: ScenarioItemTypeNew.RANSOMWARE_NOTE,
        name: 'ADMIN.SCENARIO_ITEM_TYPE.RANSOMWARE_NOTE',
      },
      {
        value: ScenarioItemTypeNew.TEXT,
        name: 'ADMIN.SCENARIO_ITEM_TYPE.TEXT',
      },
      {
        value: ScenarioItemTypeNew.FACEBOOK,
        name: 'ADMIN.SCENARIO_ITEM_TYPE.FACEBOOK',
      },
      {
        value: ScenarioItemTypeNew.TWITTER,
        name: 'ADMIN.SCENARIO_ITEM_TYPE.TWITTER',
      },
      {
        value: ScenarioItemTypeNew.AUDIO,
        name: 'ADMIN.SCENARIO_ITEM_TYPE.AUDIO',
      },
      {
        value: ScenarioItemTypeNew.VIDEO,
        name: 'ADMIN.SCENARIO_ITEM_TYPE.VIDEO',
      },
      {
        value: ScenarioItemTypeNew.IMAGE,
        name: 'ADMIN.SCENARIO_ITEM_TYPE.IMAGE',
      },
      { value: ScenarioItemTypeNew.PDF, name: 'ADMIN.SCENARIO_ITEM_TYPE.PDF' },
      {
        value: ScenarioItemTypeNew.HYPERLINK,
        name: 'ADMIN.SCENARIO_ITEM_TYPE.HYPERLINK',
      },
      {
        value: ScenarioItemTypeNew.GOOGLE_EARTH,
        name: 'ADMIN.SCENARIO_ITEM_TYPE.GOOGLE_EARTH',
      },
      {
        value: ScenarioItemTypeNew.GOOGLE_MAP,
        name: 'ADMIN.SCENARIO_ITEM_TYPE.GOOGLE_MAP',
      },
      {
        value: ScenarioItemTypeNew.OPEN_FORUM,
        name: 'ADMIN.SCENARIO_ITEM_TYPE.OPEN_FORUM',
      },
      {
        value: ScenarioItemTypeNew.QUESTION,
        name: 'ADMIN.SCENARIO_ITEM_TYPE.QUESTION',
      },
      {
        value: ScenarioItemTypeNew.MULTI_CHOICE,
        name: 'ADMIN.SCENARIO_ITEM_SUBTYPE.MULTI_CHOICE',
      },
      {
        value: ScenarioItemTypeNew.LINEAR,
        name: 'ADMIN.SCENARIO_ITEM_SUBTYPE.LINEAR_SCALE',
      },
      {
        value: ScenarioItemTypeNew.POLL,
        name: 'ADMIN.SCENARIO_ITEM_SUBTYPE.POLL',
      },
      { value: ScenarioItemTypeNew.MS_TEAMS, name: 'ADMIN.CALL_TYPE.MS_TEAMS' },
      { value: ScenarioItemTypeNew.CHIME, name: 'ADMIN.CALL_TYPE.CHIME' },
      { value: ScenarioItemTypeNew.ZOOM, name: 'ADMIN.CALL_TYPE.ZOOM' },
      {
        value: ScenarioItemTypeNew.GOOGLE_MEETS,
        name: 'ADMIN.CALL_TYPE.GOOGLE_MEETS',
      },

      {
        value: ScenarioItemTypeNew.EMBEDDED_FACEBOOK,
        name: 'ADMIN.EMBEDDED.FACEBOOK',
      },
      {
        value: ScenarioItemTypeNew.EMBEDDED_FLOURISH,
        name: 'ADMIN.EMBEDDED.FLOURISH',
      },
      {
        value: ScenarioItemTypeNew.EMBEDDED_SLIDO,
        name: 'ADMIN.EMBEDDED.SLIDO',
      },
      {
        value: ScenarioItemTypeNew.EMBEDDED_GOOGLE_DOCS,
        name: 'ADMIN.EMBEDDED.GOOGLE_DOCS',
      },
      {
        value: ScenarioItemTypeNew.EMBEDDED_GOOGLE_SHEETS,
        name: 'ADMIN.EMBEDDED.GOOGLE_SHEETS',
      },
      {
        value: ScenarioItemTypeNew.EMBEDDED_GOOGLE_SLIDES,
        name: 'ADMIN.EMBEDDED.GOOGLE_SLIDES',
      },
      {
        value: ScenarioItemTypeNew.EMBEDDED_GOOGLE_FORMS,
        name: 'ADMIN.EMBEDDED.GOOGLE_FORMS',
      },
      {
        value: ScenarioItemTypeNew.EMBEDDED_DATAWRAPPER,
        name: 'ADMIN.EMBEDDED.DATAWRAPPER',
      },
      {
        value: ScenarioItemTypeNew.TEXT_WITH_AUTHOR,
        name: 'ADMIN.SCENARIO_ITEM_TYPE.TEXT_MESSAGE',
      },
      {
        value: ScenarioItemTypeNew.YOUTUBE,
        name: 'ADMIN.SCENARIO_ITEM_TYPE.YOUTUBE',
      },
      {
        value: ScenarioItemTypeNew.VIMEO,
        name: 'ADMIN.SCENARIO_ITEM_TYPE.VIMEO',
      },
      {
        value: ScenarioItemTypeNew.BRIGHTCOVE,
        name: 'ADMIN.SCENARIO_ITEM_TYPE.BRIGHTCOVE',
      },
    ];
  }

  getCallTypes() {
    return [
      { value: ScenarioItemSubType.MS_TEAMS, name: 'ADMIN.CALL_TYPE.MS_TEAMS' },
      { value: ScenarioItemSubType.CHIME, name: 'ADMIN.CALL_TYPE.CHIME' },
      { value: ScenarioItemSubType.ZOOM, name: 'ADMIN.CALL_TYPE.ZOOM' },
      {
        value: ScenarioItemSubType.GOOGLE_MEETS,
        name: 'ADMIN.CALL_TYPE.GOOGLE_MEETS',
      },
    ];
  }

  sendInvite(id, data): Observable<any> {
    return this.http
      .post(apiResourcesV1.sessions + '/' + id + '/participants/invite', data)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  sendReportEmails(trainingId, params) {
    return this.http
      .post(
        `${apiResourcesV1.sessions}/${trainingId}/send_session_final_email`,
        params
      )
      .pipe(
        map((res: any) => {
          return res?.data;
        })
      );
  }
  startSession(id): Observable<Session> {
    return this.http.post(`${apiResourcesV1.sessions}/${id}/start`, {}).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  sendScenarioItemAnswer(trainingId, scenarioId, id, data): Observable<any> {
    return this.http
      .post(
        `${apiResourcesV1.sessions}/${trainingId}/scenarios/${scenarioId}/items/${id}/answer`,
        data
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  getSessionsPagination(data: any): Observable<any> {
    return this.http.get(apiResourcesV1.sessions, data).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  getSession(id: number, data = {}): Observable<Session> {
    return this.http.get(`${apiResourcesV1.sessions}/${id}`, data).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  getScenario(id: number, scenarioId: number): Observable<Scenario> {
    return this.http
      .get(`${apiResourcesV1.sessions}/${id}/scenarios/${scenarioId}`)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  addSession(data): Observable<any> {
    return this.http.post(apiResourcesV1.sessions, data).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  updateSession(id, data): Observable<any> {
    return this.http.put(`${apiResourcesV1.sessions}/${id}`, data).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  deleteSession(id): Observable<any> {
    return this.http.delete(`${apiResourcesV1.sessions}/${id}`).pipe(
      map((res: any) => {
        return res;
      })
    );
  }
  getTeams(id) {
    return this.http
      .get(`${apiResourcesV1.sessions}/${id}/teams`, { per_page: 200 })
      .pipe(
        map((res: any) => {
          if (res?.data) {
            return res.data;
          }
          return null;
        })
      );
  }
  getTeam(trainingId, id) {
    return this.http
      .get(`${apiResourcesV1.sessions}/${trainingId}/teams/${id}`)
      .pipe(
        map((res: any) => {
          if (res?.data) {
            return res.data;
          }
          return null;
        })
      );
  }
  updateTeam(id, data, teamId): Observable<any> {
    return this.http
      .put(`${apiResourcesV1.sessions}/${id}/teams/${teamId}`, data)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  deleteTeam(trainingId, id): Observable<any> {
    return this.http
      .delete(`${apiResourcesV1.sessions}/${trainingId}/teams/${id}`)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  addTeam(trainingId, data): Observable<any> {
    return this.http
      .post(`${apiResourcesV1.sessions}/${trainingId}/teams`, data)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  getTrainingParticipants(trainingId, params = {}) {
    return this.http
      .get(`${apiResourcesV1.sessions}/${trainingId}/participants`, params)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  deleteParticipantFromTraining(trainingId, id) {
    return this.http
      .delete(`${apiResourcesV1.sessions}/${trainingId}/participants/${id}`)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  addToTraining(sessionId, data = {}): Observable<any> {
    return this.http
      .post(`${apiResourcesV1.sessions}/${sessionId}/participants`, data)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  getReferences(trainingId, params = {}): Observable<any> {
    params['with'] = ['media'];
    return this.http
      .get(`${apiResourcesV1.sessions}/${trainingId}/references`, params)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  getSessions(data: any = null): Observable<Session[]> {
    return this.http.get(apiResourcesV1.sessions, data).pipe(
      map((res: any) => {
        if (res?.data?.length) {
          return res.data;
        }
        return [];
      })
    );
  }

  deleteReferences(id, idRef): Observable<any> {
    return this.http
      .delete(`${apiResourcesV1.sessions}/${id}/references/${idRef}`)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  uploadUpdateReferences(id, idRef, data = null): Observable<any> {
    return this.http
      .patch(`${apiResourcesV1.sessions}/${id}/references/${idRef}`, data)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  uploadAddReference(trainingId, file = null, data = null): Observable<any> {
    return this.http
      .post(`${apiResourcesV1.sessions}/${trainingId}/references`, data)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  addScenarioItem(
    trainingSessionId,
    data,
    scenarioId
  ): Observable<ScenarioItem> {
    return this.http
      .post(
        `${apiResourcesV1.sessions}/${trainingSessionId}/scenarios/${scenarioId}/items`,
        data
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  updateScenarioItem(
    id,
    trainingSessionId,
    scenarioId,
    data
  ): Observable<ScenarioItem> {
    return this.http
      .put(
        `${apiResourcesV1.sessions}/${trainingSessionId}/scenarios/${scenarioId}/items/${id}`,
        data
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  deleteScenarioItem(id, trainingId, scenarioId): Observable<any> {
    return this.http
      .delete(
        `${apiResourcesV1.sessions}/${trainingId}/scenarios/${scenarioId}/items/${id}`
      )

      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  exportScenarioItems(trainingId, scenarioId, data): Observable<any> {
    return this.http
      .post(
        `${apiResourcesV1.sessions}/${trainingId}/scenarios/${scenarioId}/export`,
        data
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  getScenarioItems(
    trainingId,
    scenarioId,
    params = null
  ): Observable<ScenarioItem[]> {
    params['per_page'] = 200;
    return this.http
      .get(
        `${apiResourcesV1.sessions}/${trainingId}/scenarios/${scenarioId}/items`,
        params
      )
      .pipe(
        map((res: any) => {
          if (res?.data?.length) {
            return res.data;
          }
          return [];
        })
      );
  }

  getScenarioItem(trainingSessionId, scenarioId, id): Observable<ScenarioItem> {
    return this.http
      .get(
        `${apiResourcesV1.participantSessions}/${trainingSessionId}/scenarios/${scenarioId}/items/${id}`
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  deleteAnswer(sessionItemId, trainingId, scenarioId, id): Observable<any> {
    return this.http
      .delete(
        `${apiResourcesV1.sessions}/${trainingId}/scenarios/${scenarioId}/items/${sessionItemId}/options/${id}`
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  updateScenario(trainingId, id, data): Observable<any> {
    return this.http
      .put(`${apiResourcesV1.sessions}/${trainingId}/scenarios/${id}`, data)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  getScenarios(id, params = {}): Observable<Scenario[]> {
    return this.http
      .get(`${apiResourcesV1.sessions}/${id}/scenarios`, params)
      .pipe(
        map((res: any) => {
          return res.data;
        })
      );
  }

  deleteScenario(trainingId, id): Observable<Scenario> {
    return this.http
      .delete(`${apiResourcesV1.sessions}/${trainingId}/scenarios/${id}`)
      .pipe(
        map((res: any) => {
          return res?.data;
        })
      );
  }

  addScenario(trainingId, data): Observable<any> {
    return this.http
      .post(`${apiResourcesV1.sessions}/${trainingId}/scenarios`, data)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  pauseMedia(id): Observable<Session> {
    return this.http.post(`${apiResourcesV1.sessions}/${id}/pause`, {}).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  pauseSession(id): Observable<Session> {
    return this.http
      .post(`${apiResourcesV1.sessions}/${id}/pause`, { is_full_pause: 1 })
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  resumeSession(id): Observable<Session> {
    return this.http.post(`${apiResourcesV1.sessions}/${id}/resume`, {}).pipe(
      map((res: any) => {
        return res;
      })
    );
  }
  startScenarioItem(trainingId, scenarioId, id, params = {}): Observable<any> {
    return this.http
      .post(
        `${apiResourcesV1.sessions}/${trainingId}/scenarios/${scenarioId}/items/${id}/start`,
        params
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  pauseScenarioItem(trainingId, scenarioId, id): Observable<any> {
    return this.http
      .post(
        `${apiResourcesV1.sessions}/${trainingId}/scenarios/${scenarioId}/items/${id}/pause`,
        {}
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  resumeScenarioItem(trainingId, scenarioId, id): Observable<any> {
    return this.http
      .post(
        `${apiResourcesV1.sessions}/${trainingId}/scenarios/${scenarioId}/items/${id}/resume`,
        {}
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  startScenario(trainingId, id): Observable<any> {
    return this.http
      .post(
        `${apiResourcesV1.sessions}/${trainingId}/scenarios/${id}/start`,
        {}
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  completeScenario(trainingId, id, params = {}): Observable<any> {
    return this.http
      .post(
        `${apiResourcesV1.sessions}/${trainingId}/scenarios/${id}/complete`,
        params
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  completeSession(id, params): Observable<Session> {
    return this.http
      .post(`${apiResourcesV1.sessions}/${id}/complete`, params)
      .pipe(
        map((res: any) => {
          return res?.data;
        })
      );
  }

  getLogs(trainingId, params) {
    return this.http
      .get(`${apiResourcesV1.sessions}/${trainingId}/logs`, params)
      .pipe(
        map((test: any) => {
          if (test?.data) {
            return test.data;
          }
          return [];
        })
      );
  }

  getParticipation(id) {
    return this.http.get(`${apiResourcesV1.sessions}/${id}/participation`).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  setTeam(id, data) {
    return this.http
      .post(`${apiResourcesV1.sessions}/${id}/participation/set_team`, data)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  approveParticipation(id) {
    return this.http
      .post(`${apiResourcesV1.sessions}/${id}/participation/approve`, {})
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  sendEmailInvite(id, data): Observable<any> {
    return this.http
      .post(
        apiResourcesV1.sessions + '/' + id + '/participants/invite_by_email',
        data
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  getVoteResults(trainingId, sessionId, params = {}) {
    return this.http
      .get(`${apiResourcesV1.sessions}/${trainingId}/votes`, params)
      .pipe(
        map((res: any) => {
          return res.data;
        })
      );
  }

  setTeamLeader(trainingId, teamId, data): Observable<any> {
    return this.http
      .post(
        `${apiResourcesV1.sessions}/${trainingId}/teams/${teamId}/set_team_lead`,
        data
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  duplicateSession(id, params) {
    return this.http.post(`${apiResourcesV1.sessions}/${id}/copy`, params).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  getSessionMedia(id) {
    return this.http.get(`${apiResourcesV1.sessions}/${id}/media`).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  assignItemsToAll(sessionId, scenarioId) {
    return this.http
      .post(
        `${apiResourcesV1.sessions}/${sessionId}/scenarios/${scenarioId}}/items/assign_to_all_teams`,
        {}
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  getScenarioItemTypesByGroup() {
    return [
      {
        type: ScenarioItemTypeNew.NEWS_POST,
        group: 'text',
      },
      {
        type: ScenarioItemTypeNew.RANSOMWARE_LEAK_SITE,
        group: 'text',
      },
      {
        type: ScenarioItemTypeNew.WEB_POST_DATA,
        group: 'text',
      },
      {
        type: ScenarioItemTypeNew.PHONE_CALL_TRANSCRIPT,
        group: 'files',
      },
      {
        type: ScenarioItemTypeNew.TEAM_CHAT,
        group: 'text',
      },
      {
        type: ScenarioItemTypeNew.RANSOMWARE_NOTE,
        group: 'text',
      },
      {
        type: ScenarioItemTypeNew.SERVICE_DESK_TICKET,
        group: 'text',
      },
      {
        type: ScenarioItemTypeNew.EMAIL,
        group: 'text',
      },
      {
        type: ScenarioItemTypeNew.TEXT,
        group: 'text',
      },
      {
        type: ScenarioItemTypeNew.TEXT_WITH_AUTHOR,
        group: 'text',
      },
      {
        type: ScenarioItemTypeNew.FACEBOOK,
        group: 'text',
      },
      {
        type: ScenarioItemTypeNew.TWITTER,
        group: 'text',
      },
      {
        type: ScenarioItemTypeNew.OPEN_FORUM,
        group: 'text',
      },
      {
        type: ScenarioItemTypeNew.AUDIO,
        group: 'files',
      },
      {
        type: ScenarioItemTypeNew.VIDEO,
        group: 'files',
      },
      {
        type: ScenarioItemTypeNew.IMAGE,
        group: 'files',
      },
      {
        type: ScenarioItemTypeNew.PDF,
        group: 'files',
      },
      {
        type: ScenarioItemTypeNew.HYPERLINK,
        group: 'links',
      },
      {
        type: ScenarioItemTypeNew.YOUTUBE,
        group: 'links',
      },
      {
        type: ScenarioItemTypeNew.VIMEO,
        group: 'links',
      },
      {
        type: ScenarioItemTypeNew.BRIGHTCOVE,
        group: 'links',
      },
      {
        type: ScenarioItemTypeNew.GOOGLE_MAP,
        group: 'links',
      },
      {
        type: ScenarioItemTypeNew.MS_TEAMS,
        group: 'links',
      },
      {
        type: ScenarioItemTypeNew.GOOGLE_EARTH,
        group: 'files',
      },
      {
        type: ScenarioItemTypeNew.ZOOM,
        group: 'links',
      },
      {
        type: ScenarioItemTypeNew.CHIME,
        group: 'links',
      },
      {
        type: ScenarioItemTypeNew.GOOGLE_MEETS,
        group: 'links',
      },
      {
        type: ScenarioItemTypeNew.QUESTION,
        group: 'questions',
      },
      {
        type: ScenarioItemTypeNew.POLL,
        group: 'questions',
      },
      {
        type: ScenarioItemTypeNew.LINEAR,
        group: 'questions',
      },
      {
        type: ScenarioItemTypeNew.MULTI_CHOICE,
        group: 'questions',
      },
      {
        type: ScenarioItemTypeNew.BRANCHING,
        group: 'questions',
      },
      {
        type: ScenarioItemTypeNew.EMBEDDED_DATAWRAPPER,
        group: 'embedded',
      },
      {
        type: ScenarioItemTypeNew.EMBEDDED_SLIDO,
        group: 'embedded',
      },
      {
        type: ScenarioItemTypeNew.EMBEDDED_FLOURISH,
        group: 'embedded',
      },
      {
        type: ScenarioItemTypeNew.EMBEDDED_FACEBOOK,
        group: 'embedded',
      },
      {
        type: ScenarioItemTypeNew.EMBEDDED_GOOGLE_SLIDES,
        group: 'embedded',
      },
      {
        type: ScenarioItemTypeNew.EMBEDDED_GOOGLE_SHEETS,
        group: 'embedded',
      },
      {
        type: ScenarioItemTypeNew.EMBEDDED_GOOGLE_DOCS,
        group: 'embedded',
      },
      {
        type: ScenarioItemTypeNew.EMBEDDED_GOOGLE_FORMS,
        group: 'embedded',
      },
    ];
  }

  getItemGroups() {
    return ['text', 'files', 'links', 'questions', 'embedded'];
  }
}
